import { Breakpoints } from '@angular/cdk/layout';

export const MediaQueries = {
  XS: Breakpoints.XSmall,
  SM: Breakpoints.Small,
  MD: Breakpoints.Medium,
  LG: Breakpoints.Large,
  XL: Breakpoints.XLarge,
  LT_SM: '(max-width: 599.98px)', // This is identical to XS
  LT_MD: '(max-width: 959.98px)',
  LT_LG: '(max-width: 1279.98px)',
  LT_XL: '(max-width: 1919.98px)',
  GT_XS: '(min-width: 600px)',
  GT_SM: '(min-width: 960px)',
  GT_MD: '(min-width: 1280px)',
  GT_LG: '(min-width: 1920px)', // This is identical to XL
};
